// Sticky header scroll behavior
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.pageheader--sticky');
  if (!header) return;

  let lastScrollTop = 0;
  let isScrollingUp = false;
  let scrollTimeout;

  header.classList.add('pageheader--sticky-custom');
  
  document.body.classList.add('has-sticky-header');

  function handleScroll() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (currentScrollTop <= 100) {
      header.classList.remove('pageheader--sticky--hidden', 'pageheader--sticky--visible');
      header.classList.add('pageheader--sticky--at-top');
      lastScrollTop = currentScrollTop;
      return;
    }

    header.classList.remove('pageheader--sticky--at-top');
    
    if (currentScrollTop > lastScrollTop) {

      isScrollingUp = false;
      header.classList.remove('pageheader--sticky--visible');
      header.classList.add('pageheader--sticky--hidden');
    } else if (currentScrollTop < lastScrollTop) {

      isScrollingUp = true;
      header.classList.remove('pageheader--sticky--hidden');
      header.classList.add('pageheader--sticky--visible');
    }

    lastScrollTop = currentScrollTop;

    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }

    scrollTimeout = setTimeout(() => {
      if (!isScrollingUp && currentScrollTop > 100) {
        header.classList.remove('pageheader--sticky--visible');
        header.classList.add('pageheader--sticky--hidden');
      }
    }, 150);
  }

  let ticking = false;
  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  }

  handleScroll();

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick, { passive: true });
});
